import React, { useEffect } from "react"
import { Row, Col } from "antd"
import {
	Navbar,
	Hero,
	Companies,
	Features,
	Banner,
	Contact,
	Footer,
} from "../components/landingview"
import styled from "styled-components"
import Helmet from "react-helmet"
import * as Sentry from "@sentry/react";


Sentry.init({
	dsn: "https://ceb44551b388485eb468ffb0b3813eb9@notmyfault.workclass.co/3",
});


const BlueBackground = styled.div`
	background-color: #f7f8ff;
	z-index: -1;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 800px;
`

const IndexPage = (): React.FC => {

	useEffect(() => {



		const script = document.createElement('script');

		script.src = "https://use.typekit.net/foobar.js";
		script.async = true;

		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		}


	}, [])


	return (
		<React.Fragment>
			<Helmet>
				<title>WorkClass</title>
				<meta
					name="description"
					content="WorkClass is the leading frontline staff hiring platform in Singapore. Get up to 15 pre-filtered candidates within the first hour of a job post. Ask additional screening questions before engaging with the candidate."
				/>
				<meta
					name="keywords"
					content="jobs, workclass, workclass.co, work class, hire, employment, job search, searching for jobs"
				/>
			</Helmet>
			<div id="Home">
				<Navbar />
				<Row>
					<BlueBackground />
					<Col sm={{ push: 0, span: 24 }} md={{ push: 3, span: 18 }}>
						<Hero />
						<Companies />
						<Features />
					</Col>

					<Col span={24}>
						<Banner />
					</Col>

					<Col push={3} span={18}>
						<Contact />
						<Footer />
					</Col>
				</Row>
			</div>
		</React.Fragment>
	)
}

export default IndexPage
